// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
// Sibling imports
const suSubmitModalActions = require('./actions')
const StumbleUponSubmitModal = require('./component-dumb')

function mapStateToProps(state) {
  if (state.suSubmitModal) {
    return {
      isVisible: !state.authModal.isVisible,
      addHref: state.suSubmitModal.addHref
    }
  }
  return {
    isVisible: false
  }
}

const mapDispatchToProps = {
  onDismiss: suSubmitModalActions.close,
  onLoginClick: authModalActions.showLogin,
  onSignupClick: authModalActions.showSignup
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  StumbleUponSubmitModal
)
